module.exports = __webpack_public_path__ + "img/introducePageFive_show_three.998380bc.jpg";